module.exports = __webpack_public_path__ + "img/WP2023-first-congress-1200-1200.91a55191.png";